import {ChangeDetectionStrategy, Component, computed, inject, OnInit, signal} from "@angular/core"
import {ActivatedRoute} from "@angular/router"
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner"
import {mutateThrowingErrors} from "@common/helpers/api/mutate"
import {NotificationsService} from "@common/services/notifications/notifications.service"
import {StartSsoLoginGQL} from "@pages/login/tenant-login-page.generated"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-tenant-login-page",
    templateUrl: "tenant-login-page.component.html",
    styleUrls: ["tenant-login-page.component.scss"],
    imports: [MatProgressSpinnerModule],
})
export class TenantLoginPageComponent implements OnInit {
    private readonly route = inject(ActivatedRoute)
    private readonly notifications = inject(NotificationsService)
    private readonly startSsoLoginGql = inject(StartSsoLoginGQL)

    readonly $slug = signal("")
    readonly $tenantName = computed(() => {
        const slug = this.$slug()
        return slug ? slug.charAt(0).toUpperCase() + slug.slice(1) : ""
    })
    readonly $busy = signal(false)
    readonly $unknownTenant = signal(false)

    ngOnInit() {
        const slug = this.route.snapshot.paramMap.get("slug") ?? ""
        this.$slug.set(slug)
        this.$unknownTenant.set(slug === "")
    }

    async signIn(): Promise<void> {
        const slug = this.$slug()
        if (!slug) {
            this.$unknownTenant.set(true)
            return
        }
        this.$busy.set(true)
        try {
            const {startSsoLogin} = await mutateThrowingErrors(this.startSsoLoginGql)({slug})
            if (startSsoLogin) {
                window.location.href = startSsoLogin
            } else {
                this.$unknownTenant.set(true)
                this.$busy.set(false)
            }
        } catch (error) {
            this.notifications.showError(error)
            this.$busy.set(false)
        }
    }
}
